module.exports = __webpack_public_path__ + "media/images/about__our-culture-2-da6f5756a00dde9b17bb834bb152b16c.jpg";